/**
 * @file TransferNotePrintButton.tsx
 * @description Кнопка «Накладная» в шапке проведённого перемещения
 * (phase19.23 этап B).
 *
 * Накладная нужна только межскладскому переезду: там меняется материально
 * ответственное лицо и нужны подписи «отпустил / принял». У документа из одних
 * перестановок по ячейкам сервер отвечает `transfer_internal_only`, поэтому
 * кнопку в таком случае не показываем вовсе (решение принимает страница).
 */

import { Loader2, Printer } from "lucide-react";
import { useState } from "react";

import { Button } from "../../ui/button";
import { useNotify } from "../../ui/NotifyProvider";
import { transfersApi } from "../../../lib/api-transfers";
import { saveBlob } from "../../../lib/download";
import { wmsErrorText } from "../../../lib/wms-error-text";

interface Props {
  transferId: string;
  /** Номер документа — попадает в имя файла. */
  number: string;
}

export function TransferNotePrintButton({ transferId, number }: Props) {
  const notify = useNotify();
  const [printing, setPrinting] = useState(false);

  async function handlePrint() {
    setPrinting(true);
    try {
      const file = await transfersApi.printNote(transferId, number);
      saveBlob(file.blob, file.filename);
    } catch (err) {
      notify.error(wmsErrorText(err, "Не удалось получить накладную"));
    } finally {
      setPrinting(false);
    }
  }

  return (
    <Button
      variant="outline"
      disabled={printing}
      onClick={() => void handlePrint()}
    >
      {printing ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <Printer className="size-4" />
      )}
      <span className="ml-2">{printing ? "Готовим…" : "Накладная"}</span>
    </Button>
  );
}
